import { type VariantProps, cva } from "class-variance-authority";
import type * as React from "react";

import { cn } from "@/lib/utils";

const badgeVariants = cva(
  "inline-flex items-center px-1.5 py-0.5 text-xs font-medium focus:outline-none border",
  {
    variants: {
      variant: {
        default: "bg-olive-3 text-olive-11 border-olive-5",
        primary: "bg-farmless-green/10 text-farmless-green border-farmless-green/20",
        secondary: "bg-olive-4 text-olive-10 border-olive-6",
        destructive: "bg-tomato-3 text-tomato-11 border-tomato-6",
        warning: "bg-yellow-3 text-yellow-11 border-yellow-6",
        success: "bg-grass-3 text-grass-11 border-grass-6",
        outline: "bg-transparent text-olive-11 border-olive-6",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  },
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return (
    <div className={cn(badgeVariants({ variant }), className)} {...props} />
  );
}

export { Badge, badgeVariants };
